<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Assigned" subtitle="Browse volunteers and see their schedules." :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-panel text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" :disabled="!collection.length" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />
		
		<app-content-filters-checklist v-model="filter.roles" text="Role" tooltip="Select roles" :options="references.roles" />
		
		<app-content-filters-checklist v-model="filter.days" text="Day" tooltip="Select days" :options="references.days" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no volunteers found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column  text="Badge" />

				<app-table-column align="center" text="Roles" />

				<app-table-column align="center" text="Slots" />
			
				<app-table-column align="center" text="Hours" />

				<app-table-column align="center" text="Days" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-item type="convention/badge" :item="item" />

					<app-table-cell-text align="center" :text="item.count.volunteer.roles" />

					<app-table-cell-text align="center" :text="item.count.volunteer.slots" />

					<app-table-cell-text align="center" :text="item.count.volunteer.hours" />

					<app-table-cell-days align="center" :days="references.days" :active="item.count.volunteer.days" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				days: [],
				roles: []
			},
			filter: {
				search: '',
				days: [],
				roles: []
			},
			layout: 'auto 100px 100px 100px 260px',
			endpoint: 'convention/volunteers/badges',
			live: 'convention/volunteers/badges'
		}

	},

	computed: {

		importexportData: function() {

			return {
				columns: {
					reference: 'Reference',
					firstname: 'First Name',
					lastname: 'Last Name',
					email: 'E-mail',
					volunteerRoles: 'Roles',
					volunteerSlots: 'Slots',
					volunteerHours: 'Hours',
					volunteerDays: 'Days'
				},
				requiredColumns: [],
				valueMapping: [],
				params: {},
				index: this.selectedIndex,
				endpoint: this.$endpoint(this.endpoint)
			}

		}
	
	}

}

</script>

<style scoped>

</style>